// @general/users - frontend surface.

export { usersApi, rolesApi } from './api'

export const routes = [
  {
    path: '/users',
    name: 'users',
    component: () => import('./views/UsersView.vue'),
    meta: { permission: 'users:read', title: 'users.title' },
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import('./views/RolesView.vue'),
    meta: { permission: 'roles:read', title: 'roles.title' },
  },
]

// Entries the shell renders in the sidebar. Each one is hidden automatically
// when the signed-in user lacks the permission.
export const navigation = [
  { to: '/users', labelKey: 'users.title', permission: 'users:read', icon: 'users', group: 'platform' },
  { to: '/roles', labelKey: 'roles.title', permission: 'roles:read', icon: 'shield', group: 'platform' },
]

export default { routes, navigation }
